import { render, staticRenderFns } from "./TifInspeccionGestiona.vue?vue&type=template&id=4c959258"
import script from "./TifInspeccionGestiona.vue?vue&type=script&lang=js"
export * from "./TifInspeccionGestiona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports